import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-flower-pot",
  "use": "icon-si-glyph-flower-pot-usage",
  "viewBox": "0 0 16 17",
  "content": "<symbol viewBox=\"0 0 16 17\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-flower-pot\" id=\"icon-si-glyph-flower-pot\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>1184</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g transform=\"translate(0.000000, 3.000000)\" fill=\"#434343\">\n            <path d=\"M15.25,2.965 L0.663,2.965 L0,0.083 L15.914,0.083 L15.25,2.965 Z\" class=\"si-glyph-fill\" />\n            <path d=\"M12.775,11.936 L3.139,11.936 L1.055,4.022 L14.859,4.022 L12.775,11.936 Z\" class=\"si-glyph-fill\" />\n        </g>\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-flower-pot.svg
// module id = rbZW
// module chunks = 62